import React, { useEffect, useState } from 'react';
import client, { resolveApiAssetUrl } from '../lib/api';
import { readCachedSliders } from '../lib/sliderCache';
import { slidersAt } from '../lib/sliderPlacement';

/**
 * Giriş penceresinin bannerları (CMS › Bloklar): "Giriş Ekranı Banner"
 * (`login`, pencerenin tepesinde) ve "Sign In" (`signin`, giriş kutusunun
 * altında). İkisi de görseldir; bağlantı verilmişse tıklanınca gider.
 * Önce son bilinen banner listesi çizilir, taze liste gelince yenilenir.
 */
const AuthBanner = ({ placement, className = '' }) => {
  const [slides, setSlides] = useState(readCachedSliders);
  useEffect(() => {
    let alive = true;
    client.get('/sliders').then(({ data }) => { if (alive) setSlides(data?.items || []); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  const banner = slidersAt(slides, placement).find((slide) => slide.image);
  if (!banner) return null;
  const image = <img src={resolveApiAssetUrl(banner.image)} alt={banner.alt_text || banner.title || ''} className="w-full h-auto rounded-xl block" />;
  const link = banner.cta_link || banner.link || '';
  return (
    <div className={`auth-banner ${className}`} data-bhs-auth-banner={placement}>
      {link ? (
        <a href={link} target={banner.new_window ? '_blank' : undefined} rel={banner.new_window ? 'noopener noreferrer' : undefined}>{image}</a>
      ) : image}
    </div>
  );
};

export default AuthBanner;
